import CIMSFormItem from 'components/CIMSFormItem'
import CIMSSelect from 'components/CIMSSelect'
import { useIFITrackerContext } from '../../../../IFITrackerContext'
import { useDisabledOptions } from 'hooks/useDisabledOptions'
import { IssueSelectProps } from './types'
import { IFIStatus } from 'shared'
import { HelpMessage } from 'utils/constants'

const IssueSelect: React.FC<IssueSelectProps> = ({ statusId }) => {
  const { issues } = useIFITrackerContext()
  const [disabled, { some }] = useDisabledOptions({
    disabled: statusId === IFIStatus.Closed.id,
    reason: { why: 'only status', statusName: IFIStatus.PendingReview.name },
  })
  return (
    <CIMSFormItem
      label="Issues"
      name="issues"
      disabled={disabled}
      help={HelpMessage.IdentifiedFieldIssues.AssociatedRecordNumber('Issue')}
      description="Issues can only have one Identified Field Issue. Selected Issues will be moved to this Identified Field Issue if they are associated with another."
    >
      <CIMSSelect options={issues} disabled={some} multiple />
    </CIMSFormItem>
  )
}

export default IssueSelect
